import { render } from "./ChanelsAndSources.vue?vue&type=template&id=24f753b9"
import script from "./ChanelsAndSources.vue?vue&type=script&lang=js"
export * from "./ChanelsAndSources.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__